module.exports = __webpack_public_path__ + "static/signature-9b06ef8c0a2542f3e326a4189ceba9bb.svg";